/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions';
export function FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestAbsoluteGamesOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGames.js.map